import { useEffect } from 'react'

/** Base app name shown in the browser tab, kept in sync with index.html. */
const BASE_TITLE = 'Snoots OS'

/**
 * Sets the browser tab title for the current page, suffixed with the app name
 * (e.g. "Bella · Snoots OS"). Pass `undefined` while data is still loading to
 * leave the title untouched. Restores the base title on unmount.
 */
export function useDocumentTitle(title?: string) {
  useEffect(() => {
    if (title === undefined) return
    document.title = title ? `${title} · ${BASE_TITLE}` : BASE_TITLE
    return () => {
      document.title = BASE_TITLE
    }
  }, [title])
}
